import CloseButton from 'components/DesignSystems/buttons/CloseButton';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';

interface WizardButtonWrapperProps {
  onModalClose: () => void;
  buttonProps?: {
    onClick: () => void;
    text: string;
    isDisabled?: boolean;
    isPrimary?: boolean;
  }[];
}

export default function WizardButtonWrapper({
  onModalClose,
  buttonProps,
}: WizardButtonWrapperProps) {
  const buttonsWithPrimaryOnRight = buttonProps?.sort((a, b) =>
    a.isPrimary ? 1 : b.isPrimary ? -1 : 0
  );
  return (
    <div className="position-absolute bottom-0 p-3">
      <div className="d-flex flex-row justify-content-between align-items-center">
        <CloseButton onClose={onModalClose} />
        {buttonsWithPrimaryOnRight
          ? buttonsWithPrimaryOnRight.map((button) => (
              <StylishNewButton
                className={`${button.isPrimary ? 'button--primary' : 'button--secondary'} ms-2`}
                onClick={button.onClick}
                disabled={button.isDisabled}
                key={button.text}
              >
                {button.text}
              </StylishNewButton>
            ))
          : null}
      </div>
    </div>
  );
}
